module.exports = "data:image/gif;base64,R0lGODlhAQC0AIABAKavvgAAACH5BAEAAAEALAAAAAABALQAAAIWjIGJxqzazlux2ovlzND2rAHgSIZWAQA7"